import { ChangeDetectorRef, Component, OnInit, Renderer2 } from '@angular/core';
import { TradeModalComponent } from '../trade-modal/trade-modal.component';
import { DetailsExpandAnimation } from '../../directives/details-expand.directive';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SocketService } from '../../services/SocketService';
import { UserService } from '../../services/user.service';
import { StateService } from '../../services/state.service';
import { FirstCC, PriceFactorPipe, SecondCC } from '../../helpers/pipes';
import { Store } from '@ngrx/store';
import { MatchBoardState } from '../../store/state/reducers/matchboard.reducers';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from '../../services';
import { DateService } from '../../services/date.service';
import { PriceService } from '../../services/price.service';

@Component({
  selector: 'app-modify-order-modal',
  templateUrl: './modify-order-modal.component.html',
  styleUrls: ['./modify-order-modal.component.scss'],
  animations: [DetailsExpandAnimation]
})
export class ModifyOrderModalComponent extends TradeModalComponent implements OnInit {

  order: any;
  displayOrder: any;
  ocoOrders: any[];

  override selectedCounterPartyId: string;

  // selectedOnBehalfUser: string;

  constructor(bsModalRef: BsModalRef,
              translate: TranslateService,
              socketService: SocketService,
              httpClient: HttpClient,
              stateService: StateService,
              configurationService: ConfigurationService,
              renderer: Renderer2,
              priceFactorPipe: PriceFactorPipe,
              userService: UserService,
              firstCC: FirstCC,
              secondCC: SecondCC,
              dateService: DateService,
              store: Store<MatchBoardState>,
              priceService: PriceService,
              cdr: ChangeDetectorRef) {
    super(bsModalRef, translate, socketService, httpClient, stateService, configurationService, renderer, priceFactorPipe, userService, firstCC, secondCC, dateService, store, priceService, cdr);
  }

  override ngOnInit() {
    this.price = this.priceFactorPipe.transform(this.order.profit, this.order.sixLetterCode);
    super.ngOnInit();
    if (this.ocoOrders && this.ocoOrders.length > 0) {
      this.ocoOrders.filter(o => o.sixLetterCode !== this.trade.sixLetterCode).forEach(o => {
        const ccy = this.firstCC.transform(o.sixLetterCode);
        const dropdownItem = this.dropdownList.find(item => item.itemName === ccy);
        this.selectedItems.push(dropdownItem);
        this.onItemSelect(dropdownItem);
        this.isOcoActive = true;
      });
    }

    this.displayOrder = Object.assign({}, this.order);
  }

  override keyUpEnter(event) {
    const charCode = (event.which) ? event.which : event.key;
    if (charCode === 13) {
      if (this.front) {
        this.sendOrder();
      } else {
        this.sendInvertedOrder();
      }
    }
  }

  override sendOrder() {
    // this.socketService.send('modifyOrder', {
    //   sixLetterCode: this.displayOrder.sixLetterCode,
    //   tradeType: this.Tenors.find(t => t.value === this.selectedTenorId).value,
    //   swapPrice: Number((this.priceFactorPipe.transform(this.getMaskedPriceAsNumber(this.displayOrder.swapPrice), this.displayOrder.sixLetterCode, true)).toFixed(this.currencyPairData.swapPricePrecision)),
    //   quantity: this.getMaskedPriceAsNumber(this.displayOrder.quantity),
    //   direction: this.trade.direction,
    //   placedAs: this.isSuperUser ? this.stateService.getSelectedOnBehalfUser() : null,
    //   previousSessionDate: this.isSuperUser ? this.previousSessionDate : false,
    //   tradedCurrency: this.secondCC.transform(this.trade.sixLetterCode),
    //   isInverted: false,
    //   ocos: []
    // });

    if (this.isOcoActive) {
      this.socketService.send('modifyOrder', {
        id: this.order.id,
        sixLetterCode: this.trade.sixLetterCode,
        tradeType: this.Tenors.find(t => t.value === this.selectedTenorId).value,
        swapPrice: Number((this.priceFactorPipe.transform(this.getMaskedPriceAsNumber(), this.trade.sixLetterCode, true)).toFixed(this.currencyPairData.swapPricePrecision)),
        quantity: this.getMaskedPriceAsNumber(this.trade.quantity),
        direction: this.trade.direction,
        placedAs: this.isSuperUser ? this.selectedOnBehalfUser : null,
        previousSessionDate: this.isSuperUser ? this.previousSessionDate : false,
        tradedCurrency: this.secondCC.transform(this.trade.sixLetterCode),
        ocos: this.ocos.map(item => {
          return {
            sixLetterCode: item.sixLetterCode,
            swapPrice: Number(this.priceFactorPipe.transform(item.swapPrice, item.sixLetterCode, true).toFixed(8))
          };
        }),
        counterPartyId: this.selectedCounterPartyId
      });
    } else {
      const addOrders = this.ocos.map(o => {
        return {
          sixLetterCode: o.sixLetterCode,
          tradeType: this.Tenors.find(t => t.value === this.selectedTenorId).value,
          swapPrice: Number((this.priceFactorPipe.transform(this.getMaskedPriceAsNumber(o.swapPrice), o.sixLetterCode, true)).toFixed(this.currencyPairData.swapPricePrecision)),
          quantity: this.getMaskedPriceAsNumber(this.trade.quantity),
          direction: this.trade.direction,
          placedAs: this.isSuperUser ? this.selectedOnBehalfUser : null,
          previousSessionDate: this.isSuperUser ? this.previousSessionDate : false,
          tradedCurrency: this.secondCC.transform(this.trade.sixLetterCode),
          isInverted: false,
          ocos: [],
          counterPartyId: this.selectedCounterPartyId
        };
      });
      this.socketService.send('modifyOrder', {
        id: this.order.id,
        sixLetterCode: this.trade.sixLetterCode,
        tradeType: this.Tenors.find(t => t.value === this.selectedTenorId).value,
        swapPrice: Number((this.priceFactorPipe.transform(this.getMaskedPriceAsNumber(), this.trade.sixLetterCode, true)).toFixed(this.currencyPairData.swapPricePrecision)),
        quantity: this.getMaskedPriceAsNumber(this.trade.quantity),
        direction: this.trade.direction,
        placedAs: this.isSuperUser ? this.selectedOnBehalfUser : null,
        previousSessionDate: this.isSuperUser ? this.previousSessionDate : false,
        tradedCurrency: this.secondCC.transform(this.trade.sixLetterCode),
        ocos: [],
        counterPartyId: this.selectedCounterPartyId,
        addOrders
      });
      // this.ocos.forEach(o => {
      //   const sixLetterCode = this.getSixLetterCode(o.sixLetterCode);
      //   if (sixLetterCode) {
      //     this.socketService.send('addOrder', {
      //       sixLetterCode: o.sixLetterCode,
      //       tradeType: this.Tenors.find(t => t.value === this.selectedTenorId).value,
      //       swapPrice: Number((this.priceFactorPipe.transform(this.getMaskedPriceAsNumber(o.swapPrice), o.sixLetterCode, true)).toFixed(this.currencyPairData.swapPricePrecision)),
      //       quantity: this.getMaskedPriceAsNumber(this.trade.quantity),
      //       direction: this.trade.direction,
      //       placedAs: this.isSuperUser ? this.selectedOnBehalfUser : null,
      //       previousSessionDate: this.isSuperUser ? this.previousSessionDate : false,
      //       tradedCurrency: this.secondCC.transform(this.trade.sixLetterCode),
      //       isInverted: false,
      //       ocos: []
      //     });
      //   }
      // });
    }
    this.bsModalRef.hide();
  }

  override sendInvertedOrder() {
    if (this.isOcoActiveBack) {
      this.socketService.send('modifyOrder', {
        id: this.order.id,
        sixLetterCode: this.trade.sixLetterCode,
        tradeType: this.Tenors.find(t => t.value === this.selectedTenorId).value,
        swapPrice: Number((this.priceFactorPipe.transform(Number(this.getMaskedPriceAsNumber()) * -1, this.trade.sixLetterCode, true)).toFixed(this.currencyPairData.swapPricePrecision)),
        quantity: this.getMaskedPriceAsNumber(this.trade.quantity),
        direction: this.getOppositeDirection(this.trade.direction),
        placedAs: this.isSuperUser ? this.selectedOnBehalfUser : null,
        previousSessionDate: this.isSuperUser ? this.previousSessionDate : false,
        tradedCurrency: this.firstCC.transform(this.trade.sixLetterCode),
        ocos: this.isOcoActiveBack ? this.ocosBack.map(item => {
          return {
            sixLetterCode: item.sixLetterCode,
            swapPrice: Number(this.priceFactorPipe.transform(item.swapPrice, item.sixLetterCode, true).toFixed(8)) * -1
          };
        }) : [],
        counterPartyId: this.selectedCounterPartyId
      });
    } else {
      const addOrders = this.ocos.map(o => {
        return {
          sixLetterCode: o.sixLetterCode,
          tradeType: this.Tenors.find(t => t.value === this.selectedTenorId).value,
          swapPrice: Number((this.priceFactorPipe.transform(this.getMaskedPriceAsNumber(o.swapPrice), o.sixLetterCode, true) * -1).toFixed(this.currencyPairData.swapPricePrecision)),
          quantity: this.getMaskedPriceAsNumber(this.trade.quantity),
          direction: this.getOppositeDirection(this.trade.direction),
          placedAs: this.isSuperUser ? this.selectedOnBehalfUser : null,
          previousSessionDate: this.isSuperUser ? this.previousSessionDate : false,
          tradedCurrency: this.firstCC.transform(this.trade.sixLetterCode),
          isInverted: true,
          ocos: [],
          counterPartyId: this.selectedCounterPartyId
        };
      });
      this.socketService.send('modifyOrder', {
        id: this.order.id,
        sixLetterCode: this.trade.sixLetterCode,
        tradeType: this.Tenors.find(t => t.value === this.selectedTenorId).value,
        swapPrice: Number((this.priceFactorPipe.transform(Number(this.getMaskedPriceAsNumber()) * -1, this.trade.sixLetterCode, true)).toFixed(this.currencyPairData.swapPricePrecision)),
        quantity: this.getMaskedPriceAsNumber(this.trade.quantity),
        direction: this.getOppositeDirection(this.trade.direction),
        placedAs: this.isSuperUser ? this.selectedOnBehalfUser : null,
        previousSessionDate: this.isSuperUser ? this.previousSessionDate : false,
        tradedCurrency: this.firstCC.transform(this.trade.sixLetterCode),
        ocos: [],
        counterPartyId: this.selectedCounterPartyId,
        addOrders
      });
    }

    this.bsModalRef.hide();
  }
}
